import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import ChatBubbleRoundedIcon from '@material-ui/icons/ChatBubbleRounded'
import NotificationsIcon from '@material-ui/icons/Notifications'

import { useLayoutHeaderStyles } from './layout-header.styles'
import { MenuServiceButton } from '../../../menu-service-button'

type LayoutHeaderProps = {
  heading?: React.ReactNode
  logo?: React.ReactNode
  title?: string
  nameService: string
}

export const LayoutHeader: React.FC<LayoutHeaderProps> = (props) => {
  const classes = useLayoutHeaderStyles()

  return (
    <AppBar position="fixed" color="transparent" className={classes.root}>
      <Toolbar>
        <div className={classes.logo}>{props.logo && props.logo}</div>
        <span className={classes.rect} />
        <Typography variant="h6" className={classes.title}>
          {props.nameService}
        </Typography>
        {props.heading}
        <MenuServiceButton />
        <IconButton color="inherit">
          <ChatBubbleRoundedIcon />
        </IconButton>
        <IconButton color="inherit">
          <NotificationsIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  )
}
